import { render, staticRenderFns } from "./SidebarMenuButton.vue?vue&type=template&id=cb9bc1d6&scoped=true&"
import script from "./SidebarMenuButton.vue?vue&type=script&lang=ts&"
export * from "./SidebarMenuButton.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarMenuButton.vue?vue&type=style&index=0&id=cb9bc1d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9bc1d6",
  null
  
)

export default component.exports